import { render } from "./UserAssignServicesContent.vue?vue&type=template&id=019caf7c"
import script from "./UserAssignServicesContent.vue?vue&type=script&lang=js"
export * from "./UserAssignServicesContent.vue?vue&type=script&lang=js"

import "./UserAssignServicesContent.vue?vue&type=style&index=0&id=019caf7c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__